export const FACILITY_GO_LIVE_DATE_BLOCK = {
  id: "2fe6e3a9-8b8a-4d8f-9e7d-7c7d7c7d7c7d",
  rules: ["date", "max_length:10", "min_length:10"],
  type: "form:control",
  state: {
    visible: true,
    disabled: false,
    preFlight: false,
    clearable: false,
  },
  reference: {
    id: "facilityGoLiveDate",
    type: "TEXT",
    rules: ["date", "max_length:100"],
  },
};

export const INCLUDE_IN_AUDIT_LOG_BLOCK = {
  id: "d7041fb8-4bc4-4604-98c7-2e4adb932e5b",
  type: "form:control",
  state: {
    visible: true,
    disabled: false,
    preFlight: false,
  },
  reference: {
    id: "includeInAudit",
    type: "CHECKBOX",
    translationKey: null as any,
    choices: [
      {
        id: "includeInAuditYes",
        translationKey: "Record in Audit Log history",
        children: [
          {
            id: "8151413b-c99a-4518-81f7-32cf6f06334c",
            rules: ["max_length:50"],
            type: "form:control",
            state: {
              visible: true,
              disabled: false,
              preFlight: false,
            },
            reference: {
              id: "auditLabel",
              type: "TEXT"
            },
          }
        ]
      },
    ],
  },
};
